import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontsize/fontsizecommand
 */
import FontCommand from "../fontcommand";
import { FONT_SIZE } from "../utils";
/**
 * The font size command. It is used by {@link module:font/fontsize/fontsizeediting~FontSizeEditing}
 * to apply the font size.
 *
 *		editor.execute( 'fontSize', { value: 'small' } );
 *
 * **Note**: Executing the command without the value removes the attribute from the model.
 *
 * @extends module:font/fontcommand~FontCommand
 */

var FontSizeCommand =
/*#__PURE__*/
function (_FontCommand) {
  _inherits(FontSizeCommand, _FontCommand);

  /**
   * @inheritDoc
   */
  function FontSizeCommand(editor) {
    _classCallCheck(this, FontSizeCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(FontSizeCommand).call(this, editor, FONT_SIZE));
  }

  return FontSizeCommand;
}(FontCommand);

export { FontSizeCommand as default };